var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "main" }, [
      _c(
        "nav",
        { staticClass: "navbar navbar-expand navbar-light fixed-top" },
        [
          _c("div", { staticClass: "container" }, [
            _c(
              "a",
              { staticClass: "navbar-brand", attrs: { href: "/dashboard" } },
              [
                _c("img", {
                  staticClass: "d-block",
                  attrs: { height: "23vh", src: "/img/LogoPortoBank1.svg" },
                }),
              ]
            ),
            _c(
              "button",
              {
                staticClass:
                  "navbar-toggler navbar-toggler-right border-0 collapsed",
                attrs: {
                  type: "button",
                  "data-toggle": "collapse",
                  "data-target": "#navbar4",
                  "aria-expanded": "false",
                },
              },
              [_c("span", { staticClass: "navbar-toggler-icon small" })]
            ),
            _c(
              "div",
              {
                staticClass: "navbar-collapse collapse",
                attrs: { id: "navbar4" },
              },
              [
                _c(
                  "p",
                  { staticClass: "small text-info title-space mb-2 mt-2" },
                  [_vm._v("Negocie Porto Bank")]
                ),
                _c("ul", { staticClass: "navbar-nav ml-auto text-center" }),
                _c("div", { staticClass: "space1 d-none d-sm-block" }),
                _c("div", { staticClass: "text-center" }, [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-zul ml-auto",
                      attrs: { href: "login3.html" },
                    },
                    [_vm._v("Negociar")]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "capa-erro",
          staticStyle: { "background-color": "#eef4f0" },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "align-items-center justify-content-center col-sm-12 col-12 d-flex col-md-12 col-lg-12 px-4",
                },
                [
                  _c("i", {
                    staticClass:
                      "fa fa-2x fa-exclamation-circle pull-left mr-4 mb-2 text-primary",
                  }),
                  _c("h4", { staticClass: "py-4 text-primary" }, [
                    _vm._v(
                      "No momento não temos uma oferta disponível para você. "
                    ),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "row pb-5" }, [
              _c(
                "div",
                {
                  staticClass:
                    "align-items-center justify-content-center col-sm-12 col-12 d-flex col-md-12 col-lg-12 px-4",
                },
                [
                  _c("h6", { staticClass: "py-2 text-muted" }, [
                    _vm._v(
                      "Conte com a gente para ter um alívio financeiro! É só selecionar o produto e acionar o atendimento que preferir:"
                    ),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "row mb-5" }, [
              _c("div", { staticClass: "col-12 col-lg-3 px-4" }, [
                _c("h4", { staticClass: "py-4" }, [
                  _vm._v("Central de Relacionamento Cartão de Crédito "),
                ]),
                _c("p", [
                  _c(
                    "a",
                    { attrs: { href: "tel:40043600", target: "_blank" } },
                    [_vm._v("4004 3600")]
                  ),
                  _vm._v(" - Capitais e regiões metropolitanas. "),
                  _c("br"),
                  _c(
                    "a",
                    { attrs: { href: "tel:08007277477", target: "_blank" } },
                    [_vm._v("0800 727 7477")]
                  ),
                  _vm._v(" - Demais localidades. "),
                  _c("br"),
                  _c(
                    "a",
                    { attrs: { href: "tel:551133663216", target: "_blank" } },
                    [_vm._v("+55 11 3366 3216")]
                  ),
                  _vm._v(" - Atendimento no exterior. "),
                  _c("br"),
                  _vm._v("De segunda a sexta-feira, das 8h às 18h30."),
                ]),
              ]),
              _c("div", { staticClass: "p-0 px-4 col-12 col-lg-3" }, [
                _c("h4", { staticClass: "py-4" }, [
                  _vm._v(
                    "Central de Relacionamento Cartão de Crédito Empresarial "
                  ),
                ]),
                _c("p", [
                  _c(
                    "a",
                    { attrs: { href: "tel:1140043600", target: "_blank" } },
                    [_vm._v("4004 3600")]
                  ),
                  _vm._v(" - Capitais e regiões metropolitanas."),
                  _c("br"),
                  _c(
                    "a",
                    { attrs: { href: "tel:08007277477", target: "_blank" } },
                    [_vm._v("0800-727-7477")]
                  ),
                  _vm._v(" - Demais localidades. "),
                  _c("br"),
                  _vm._v("De segunda à sexta das 7h40 às 19h00."),
                ]),
              ]),
              _c("div", { staticClass: "p-0 px-4 col-12 col-lg-3" }, [
                _c("h4", { staticClass: "py-4" }, [
                  _vm._v(
                    "Central de Relacionamento Empréstimo e Financiamento "
                  ),
                ]),
                _c("p", [
                  _c(
                    "a",
                    { attrs: { href: "tel:40045215", target: "_blank" } },
                    [_vm._v("4004 5215")]
                  ),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(
                    "De segunda a sexta-feira, das 8h às 19h (exceto feriados)."
                  ),
                ]),
              ]),
              _c("div", { staticClass: "p-0 px-4 col-12 col-lg-3" }, [
                _c("h4", { staticClass: "py-4" }, [_vm._v("SAC")]),
                _c("p", [
                  _c(
                    "a",
                    { attrs: { href: "tel:08007272745", target: "_blank" } },
                    [_vm._v("0800 727 2745")]
                  ),
                  _c("br"),
                  _vm._v("Atendimento 24 horas."),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "footer1 text-light py-4" }, [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-lg-5" }),
              ]),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }